export default class StripeError extends Error
  implements EF.ErrorWithReadableMessage {
  name = 'StripeError'
  type = 'StripeError'
  hasReadableMessage = true
}
